/* eslint-disable jsx-a11y/accessible-emoji */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  getMentorView,
  getMenteeView,
  DEFAULTS,
  goToBooking,
} from './mentorProfile';
import './ProfileView.css';

class ProfileView extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  toggleAbout = () => this.setState(s => ({ expanded: !s.expanded }));

  renderStars(rating) {
    const r = Math.round(parseFloat(rating || 0));
    return '★'.repeat(r) + '☆'.repeat(5 - r);
  }

  renderInitialsCircle(view, sizeClass) {
    const style = view.photo ? { backgroundImage: `url(${view.photo})` } : { background: view.gradient };
    return (
      <div className={`mm-ph-ring ${sizeClass}`}>
        <div className="mm-ph-photo" style={style}>
          {!view.photo && view.initials}
        </div>
      </div>
    );
  }

  renderMentorBody(view, similar) {
    const expertise = view.expertise.slice(0, 4);
    const hasAbout = view.aboutMe.length > 0;
    const aboutPreview = 400;
    const needsMore = hasAbout && view.aboutMe.length > aboutPreview;
    const shownAbout = this.state.expanded || !needsMore
      ? view.aboutMe
      : view.aboutMe.slice(0, aboutPreview) + '…';

    return (
      <div className="mm-profile-body">
        <div className="mm-content-col">
          {hasAbout && (
            <div className="mm-sec-card">
              <div className="mm-sc-title">About {view.firstName}</div>
              <div className="mm-about-txt">{shownAbout}</div>
              {needsMore && (
                <button className="mm-about-more" onClick={this.toggleAbout}>
                  {this.state.expanded ? 'Show less ↑' : 'Read more ↓'}
                </button>
              )}
            </div>
          )}

          <div className="mm-sec-card">
            <div className="mm-sc-title">Subject expertise</div>
            <div className="mm-exp-grid">
              {expertise.map((subj, i) => (
                <div className="mm-exp-card" key={i}>
                  <div className="mm-exp-icon">{view.catMeta.icon}</div>
                  <div className="mm-exp-subj">{subj}</div>
                  <div className="mm-exp-desc">{view.catMeta.expertiseDesc(subj)}</div>
                  <span className="mm-exp-lvl">{i === expertise.length - 1 ? 'Speciality' : 'Expert'}</span>
                </div>
              ))}
              {expertise.length === 0 && (
                <div className="mm-exp-card">
                  <div className="mm-exp-icon">{view.catMeta.icon}</div>
                  <div className="mm-exp-subj">{view.catMeta.label} Mentorship</div>
                  <div className="mm-exp-desc">{view.catMeta.expertiseDesc(view.catMeta.label)}</div>
                  <span className="mm-exp-lvl">Expert</span>
                </div>
              )}
            </div>
          </div>

          <div className="mm-sec-card">
            <div className="mm-sc-title">What we can discuss in a session</div>
            <div className="mm-topic-list">
              {view.catMeta.topics.map((t, i) => (
                <div className="mm-topic-row" key={i}>
                  <div className="mm-topic-num">{i + 1}</div>
                  <div className="mm-topic-name">{t.name}</div>
                  <span className={`mm-topic-pill ${t.tagClass}`}>{t.tag}</span>
                </div>
              ))}
            </div>
          </div>

          {!this.props.isOwnProfile && (
            <div className="mm-sec-card">
              <div className="mm-sc-title">Pick a slot</div>
              <p className="mm-slot-note">
                View this mentor's real availability and book on the scheduling page.
              </p>
              <button className="mm-pbc-btn" onClick={goToBooking}>
                Book a session — ₹{view.price}
              </button>
            </div>
          )}
        </div>

        <aside className="mm-sidebar-col">
          {!this.props.isOwnProfile && (
            <div className="mm-mini-book">
              <div className="mm-mb-price">₹{view.price} <sub>/ session</sub></div>
              <button className="mm-mb-btn" onClick={goToBooking}>Book a session — ₹{view.price}</button>
              <button className="mm-mb-chat" onClick={goToBooking}>💬 Send a free message</button>
            </div>
          )}

          {this.props.isOwnProfile && (
            <div className="mm-mini-book">
              <div className="mm-mb-price" style={{ marginBottom: 14 }}>Your profile</div>
              <Link className="mm-mb-btn" to={view.role === 'Mentor' ? '/mentor/create' : '/mentee'}>
                Edit profile
              </Link>
            </div>
          )}

          <div className="mm-qf-card">
            <div className="mm-qf-title">Quick facts</div>
            {view.college && (
              <div className="mm-qf-row">
                <div className="mm-qf-icon">🏛</div>
                <div>
                  <div className="mm-qf-key">College</div>
                  <div className="mm-qf-val">{view.college}</div>
                </div>
              </div>
            )}
            {view.collegeType && (
              <div className="mm-qf-row">
                <div className="mm-qf-icon">🎓</div>
                <div>
                  <div className="mm-qf-key">College type</div>
                  <div className="mm-qf-val">{view.collegeType}</div>
                </div>
              </div>
            )}
            {view.branch && (
              <div className="mm-qf-row">
                <div className="mm-qf-icon">🔬</div>
                <div>
                  <div className="mm-qf-key">Branch / Year</div>
                  <div className="mm-qf-val">{view.branch}{view.year ? ` · ${view.year}` : ''}</div>
                </div>
              </div>
            )}
            {view.category === 'CAREER' ? (
              <>
                {view.company && (
                  <div className="mm-qf-row">
                    <div className="mm-qf-icon">🏢</div>
                    <div>
                      <div className="mm-qf-key">Company</div>
                      <div className="mm-qf-val">{view.company}</div>
                    </div>
                  </div>
                )}
                {view.ppo && (
                  <div className="mm-qf-row">
                    <div className="mm-qf-icon">🎯</div>
                    <div>
                      <div className="mm-qf-key">PPO / Placed</div>
                      <div className="mm-qf-val">{view.ppo}</div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              view.rank && (
                <div className="mm-qf-row">
                  <div className="mm-qf-icon">🏆</div>
                  <div>
                    <div className="mm-qf-key">{view.category} Rank</div>
                    <div className="mm-qf-val">AIR {view.rank}</div>
                  </div>
                </div>
              )
            )}
            {view.languagesText && (
              <div className="mm-qf-row">
                <div className="mm-qf-icon">🗣</div>
                <div>
                  <div className="mm-qf-key">Language</div>
                  <div className="mm-qf-val">{view.languagesText}</div>
                </div>
              </div>
            )}
            <div className="mm-qf-row">
              <div className="mm-qf-icon">⏱</div>
              <div>
                <div className="mm-qf-key">Session duration</div>
                <div className="mm-qf-val">{DEFAULTS.duration}</div>
              </div>
            </div>
            <div className="mm-qf-row">
              <div className="mm-qf-icon">📱</div>
              <div>
                <div className="mm-qf-key">Session mode</div>
                <div className="mm-qf-val">{DEFAULTS.sessionMode}</div>
              </div>
            </div>
            <div className="mm-qf-row">
              <div className="mm-qf-icon">⚡</div>
              <div>
                <div className="mm-qf-key">Response time</div>
                <div className="mm-qf-val">Usually {DEFAULTS.responseTime}</div>
              </div>
            </div>
            {view.joined && (
              <div className="mm-qf-row">
                <div className="mm-qf-icon">📅</div>
                <div>
                  <div className="mm-qf-key">On MentoMEET since</div>
                  <div className="mm-qf-val">{view.joined}</div>
                </div>
              </div>
            )}
            {(view.fbLink || view.linkedinLink) && (
              <div className="mm-qf-row">
                <div className="mm-qf-icon">🔗</div>
                <div>
                  <div className="mm-qf-key">Social</div>
                  <div className="mm-qf-val">
                    {view.fbLink && <a href={view.fbLink} target="_blank" rel="noopener noreferrer" className="mm-social-link">Facebook</a>}
                    {view.fbLink && view.linkedinLink && ' · '}
                    {view.linkedinLink && <a href={view.linkedinLink} target="_blank" rel="noopener noreferrer" className="mm-social-link">LinkedIn</a>}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="mm-tags-card">
            <div className="mm-tags-title">Specialises in</div>
            <div className="mm-tags-wrap">
              {view.expertise.concat([view.catMeta.label]).slice(0, 8).map((tag, i) => (
                <span className="mm-stag" key={i}>{tag}</span>
              ))}
            </div>
          </div>

          {!this.props.isOwnProfile && similar.length > 0 && (
            <div className="mm-similar-card">
              <div className="mm-sim-title">Similar mentors</div>
              <div className="mm-sim-list">
                {similar.map((m, i) => (
                  <Link className="mm-sim-row" to={`/profile/${m._id}`} key={i}>
                    <div className="mm-sim-ring">
                      <div className="mm-sim-photo" style={m.photo ? { backgroundImage: `url(${m.photo})` } : { background: m.gradient }}>
                        {!m.photo && m.initials}
                      </div>
                    </div>
                    <div className="mm-sim-info">
                      <div className="mm-sim-name">{m.fullName}</div>
                      <div className="mm-sim-college">{m.college} · {m.category}</div>
                    </div>
                    <div className="mm-sim-rat">{m.rating}★</div>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </aside>
      </div>
    );
  }

  renderMenteeBody(view) {
    return (
      <div className="mm-profile-body">
        <div className="mm-content-col">
          <div className="mm-sec-card">
            <div className="mm-sc-title">About me</div>
            <div className="mm-topic-list" style={{ gap: 0 }}>
              <div className="mm-topic-row">
                <div className="mm-topic-num">1</div>
                <div className="mm-topic-name">Class / Year</div>
                <span className="mm-topic-pill mm-pill-plan">{view.standard || '—'}</span>
              </div>
              <div className="mm-topic-row">
                <div className="mm-topic-num">2</div>
                <div className="mm-topic-name">Coaching</div>
                <span className="mm-topic-pill mm-pill-plan">{view.coaching || '—'}</span>
              </div>
              <div className="mm-topic-row">
                <div className="mm-topic-num">3</div>
                <div className="mm-topic-name">Category</div>
                <span className="mm-topic-pill mm-pill-strat">{view.category || '—'}</span>
              </div>
              <div className="mm-topic-row">
                <div className="mm-topic-num">4</div>
                <div className="mm-topic-name">Subject</div>
                <span className="mm-topic-pill mm-pill-analysis">{view.subject || '—'}</span>
              </div>
            </div>
          </div>
        </div>
        <aside className="mm-sidebar-col">
          {this.props.isOwnProfile && (
            <div className="mm-mini-book">
              <div className="mm-mb-price" style={{ marginBottom: 14 }}>Your profile</div>
              <Link className="mm-mb-btn" to="/mentee">Edit profile</Link>
            </div>
          )}
          <div className="mm-qf-card">
            <div className="mm-qf-title">Quick facts</div>
            <div className="mm-qf-row">
              <div className="mm-qf-icon">👤</div>
              <div>
                <div className="mm-qf-key">Role</div>
                <div className="mm-qf-val">{view.role}</div>
              </div>
            </div>
            {view.joined && (
              <div className="mm-qf-row">
                <div className="mm-qf-icon">📅</div>
                <div>
                  <div className="mm-qf-key">On MentoMEET since</div>
                  <div className="mm-qf-val">{view.joined}</div>
                </div>
              </div>
            )}
          </div>
        </aside>
      </div>
    );
  }

  renderUnfilled(view) {
    return (
      <div className="mm-profile-body">
        <div className="mm-content-col">
          <div className="mm-sec-card">
            <div className="mm-sc-title">Profile incomplete</div>
            <p className="mm-about-txt">
              {this.props.isOwnProfile
                ? 'Please fill in your details so mentors and students can find you.'
                : 'This user has not completed their profile yet.'}
            </p>
            {this.props.isOwnProfile && (
              <Link
                className="mm-pbc-btn"
                to={view.role === 'Mentor' ? '/mentor/create' : '/mentee'}
                style={{ display: 'inline-block', textAlign: 'center', textDecoration: 'none' }}
              >
                Complete profile
              </Link>
            )}
          </div>
        </div>
        <aside className="mm-sidebar-col">
          {this.props.isOwnProfile && (
            <div className="mm-mini-book">
              <div className="mm-mb-price" style={{ marginBottom: 14 }}>Your profile</div>
              <Link className="mm-mb-btn" to={view.role === 'Mentor' ? '/mentor/create' : '/mentee'}>
                Edit profile
              </Link>
            </div>
          )}
          <div className="mm-qf-card">
            <div className="mm-qf-title">Quick facts</div>
            <div className="mm-qf-row">
              <div className="mm-qf-icon">👤</div>
              <div>
                <div className="mm-qf-key">Role</div>
                <div className="mm-qf-val">{view.role}</div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    );
  }

  render() {
    const { user, isOwnProfile } = this.props;
    if (!user) {
      return (
        <div className="mm">
          <div className="mm-loading">Profile not found</div>
        </div>
      );
    }

    const isMentor = (user.role === 'Mentor' || (user.history?.[0] && !user.history?.[0].standard));
    const view = isMentor ? getMentorView(user) : getMenteeView(user);
    const meta = isMentor ? view.catMeta : { badgeClass: 'mm-badge-board', label: view.category };

    return (
      <div className="mm">
        <div className="mm-breadcrumb">
          <Link to="/" className="mm-bc-a">Home</Link>
          <span className="mm-bc-sep">›</span>
          <Link to="/mentors" className="mm-bc-a">Mentors</Link>
          <span className="mm-bc-sep">›</span>
          <span>{view.fullName}</span>
        </div>

        <div className="mm-profile-hero">
          <div className="mm-ph-bg" />
          <div className="mm-ph-glow1" />
          <div className="mm-ph-glow2" />
          <div className="mm-ph-inner">
            <div className="mm-ph-left">
              <Link to="/mentors" className="mm-ph-back">‹ Back to mentors</Link>
              <div className="mm-ph-identity">
                {this.renderInitialsCircle(view, 'mm-ph-ring-lg')}
                <div className="mm-ph-info">
                  <div className="mm-ph-badge-row">
                    <span className={`mm-ph-domain ${meta.badgeClass}`}>{meta.icon} {meta.label}</span>
                    <span className="mm-ph-verified">✓ Verified</span>
                  </div>
                  <div className="mm-ph-name">{view.fullName}</div>
                  <div className="mm-ph-college">{isMentor ? view.college : view.category}</div>
                  <div className="mm-ph-subject">{isMentor ? view.subject : `${view.standard} · ${view.subject}`}</div>
                </div>
              </div>
              {isMentor && !isOwnProfile && (
                <div className="mm-ph-stats">
                  <div className="mm-ph-stat">
                    <div className="mm-ph-stat-num">{view.rating}★</div>
                    <div className="mm-ph-stat-lbl">Rating</div>
                  </div>
                  <div className="mm-ph-stat">
                    <div className="mm-ph-stat-num">{DEFAULTS.replyRate}</div>
                    <div className="mm-ph-stat-lbl">Reply rate</div>
                  </div>
                  <div className="mm-ph-stat">
                    <div className="mm-ph-stat-num">{DEFAULTS.responseTime}</div>
                    <div className="mm-ph-stat-lbl">Response time</div>
                  </div>
                </div>
              )}
            </div>

            {isMentor && !isOwnProfile && (
              <div className="mm-ph-book">
                <div className="mm-pbc-price-row">
                  <div className="mm-pbc-price">₹{view.price}</div>
                  <div className="mm-pbc-per">per session</div>
                </div>
                <div className="mm-pbc-save">{DEFAULTS.guarantee}</div>
                <div className="mm-pbc-feats">
                  {DEFAULTS.features.map((f, i) => (
                    <div className="mm-pbc-feat" key={i}>
                      <div className="mm-pbc-ficon">{f.icon}</div> {f.text}
                    </div>
                  ))}
                </div>
                <button className="mm-pbc-btn" onClick={goToBooking}>Book a session — ₹{view.price}</button>
                <button className="mm-pbc-chat" onClick={goToBooking}>💬 Send a free message</button>
                <div className="mm-pbc-lock">🔒 {DEFAULTS.payment}</div>
              </div>
            )}

            {isMentor && isOwnProfile && (
              <div className="mm-ph-book">
                <div className="mm-pbc-price-row">
                  <div className="mm-pbc-price" style={{ fontSize: 24 }}>Your profile</div>
                </div>
                <div className="mm-pbc-save">Manage your details and availability</div>
                <Link
                  className="mm-pbc-btn"
                  to="/mentor/create"
                  style={{ textAlign: 'center', textDecoration: 'none' }}
                >
                  Edit profile
                </Link>
              </div>
            )}
          </div>
        </div>

        {isMentor
          ? view.isFilled
            ? this.renderMentorBody(view, this.props.similar || [])
            : this.renderUnfilled(view)
          : view.isFilled
            ? this.renderMenteeBody(view)
            : this.renderUnfilled(view)}
      </div>
    );
  }
}

export default ProfileView;
